import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints-v1';
import {RemoteGetHealthProviderNames} from 'data/usecases/private/booking-flow/health-V1/remote-get-health-provider-names';
import {GetProviderNames} from 'domain/usecases/private/booking-flow/health-V1/get-health-provider-names';

export const makeGetHealthProviderNames = (): GetProviderNames =>
	new RemoteGetHealthProviderNames(
		makeBFFApiUrl(BookingFlowEndPoints.healthProviderNames),
		makeAuthorizeHttpClientDecorator(),
	);
